const fmtDate = (d) => {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
};

export const DEBT_MONTH_PRESETS = [
  { value: "0", label: "Tháng hiện tại" },
  { value: "1", label: "Tháng trước" },
  { value: "2", label: "2 tháng trước" },
  { value: "3", label: "3 tháng trước" },
  { value: "over3", label: "Trên 3 tháng" },
];

/**
 * Kỳ công nợ theo tháng lịch của khoản nợ mở cũ nhất (oldest_open_date).
 * - Preset 0..3: khoảng [đầu tháng, cuối tháng] tương ứng.
 * - over3: chỉ dateTo = ngày cuối của tháng trước (current - 3), không có dateFrom.
 */
export const buildDebtMonthRange = (monthsAgo = 0) => {
  const now = new Date();
  if (String(monthsAgo) === "over3") {
    // Last day before the start of (currentMonth - 3)
    const cutoff = new Date(now.getFullYear(), now.getMonth() - 3, 0);
    return { dateTo: fmtDate(cutoff) };
  }
  const from = new Date(now.getFullYear(), now.getMonth() - Number(monthsAgo), 1);
  const to = new Date(from.getFullYear(), from.getMonth() + 1, 0);
  return { dateFrom: fmtDate(from), dateTo: fmtDate(to) };
};

export const debtCodeStyle = (warningLevel) => {
  if (warningLevel === "RED") return { color: "#dc3545", fontWeight: 600 };
  if (warningLevel === "ORANGE") return { color: "#fd7e14", fontWeight: 600 };
  return {};
};
